import { Snippet } from '../../dataModels';

export const commentSnippet: Snippet = {
  shiftsummaryDisplyId: 'c79ecf6b-5875-ec11-913d-005056b29cce',
  name: 'A_TEST_COMMENT',
  displayName: 'COMMENTS',
  description: null,
  order: 2,
  type: 'Comment',
  count: 0,
  configuration: null,
  data: [
    {
      count: 1,
      origin: null,
      rowData: [
        {
          Note: 'test',
        },
      ],
    },
  ],
  groupSnippets: null,
};
